import React from 'react';
import { Link } from 'react-router-dom';

const AccountCTA = () => {
  return (
    <section style={{
      background: '#050A12',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(180px, 25vw, 320px)',
        fontWeight: 900, color: 'rgba(232,148,26,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>02</div>
      <div style={{
        position: 'absolute', top: '50%', left: 0, right: 0,
        height: '1px', background: 'rgba(59,111,212,0.06)',
        pointerEvents: 'none'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
          alignItems: 'center'
        }}>
          <div style={{ order: 2 }}>
            <div style={{
              background: 'linear-gradient(135deg, rgba(59,111,212,0.12) 0%, rgba(59,111,212,0.04) 100%)',
              border: '1px solid rgba(59,111,212,0.2)',
              padding: '48px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute', top: 0, right: 0,
                width: 0, height: 0,
                borderStyle: 'solid',
                borderWidth: '0 48px 48px 0',
                borderColor: 'transparent rgba(59,111,212,0.3) transparent transparent'
              }} />

              <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' }}>
                {['GRATIS', 'NORMAL', 'PREMIUM']?.map((plan, i) => (
                  <div key={plan} style={{
                    padding: '6px 16px',
                    background: i === 2 ? '#E8941A' : 'rgba(255,255,255,0.06)',
                    border: i === 2 ? '1px solid #E8941A' : '1px solid rgba(255,255,255,0.1)',
                    fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem',
                    color: i === 2 ? '#050A12' : 'rgba(238,240,242,0.5)',
                    letterSpacing: '0.2em', textTransform: 'uppercase',
                    fontWeight: i === 2 ? 700 : 400
                  }}>{plan}</div>
                ))}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '40px' }}>
                {[
                  'Sanntids veikart over hele Norge',
                  'Bomkalkulator for alle kjoretoy',
                  'Personlige rutevarslinger',
                  'Lagre opptil 5 kjoretoysprofiler'
                ]?.map((feature, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{
                      width: '20px', height: '20px', flexShrink: 0,
                      background: 'rgba(59,111,212,0.15)',
                      border: '1px solid rgba(59,111,212,0.3)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '0.65rem', color: '#3B6FD4'
                    }}>v</div>
                    <span style={{
                      fontFamily: 'Inter, sans-serif', fontSize: '0.875rem',
                      color: 'rgba(238,240,242,0.65)', lineHeight: 1.4
                    }}>{feature}</span>
                  </div>
                ))}
              </div>

              <div style={{
                position: 'absolute', bottom: '24px', right: '24px',
                border: '2px solid rgba(59,111,212,0.25)',
                padding: '8px 14px',
                transform: 'rotate(4deg)',
                fontFamily: 'Impact, Arial Black, sans-serif',
                fontSize: '0.7rem', color: 'rgba(59,111,212,0.4)',
                letterSpacing: '0.15em', textTransform: 'uppercase'
              }}>GRATIS A STARTE</div>
            </div>
          </div>

          <div style={{ order: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <div style={{ width: '40px', height: '1px', background: '#3B6FD4' }} />
              <span style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                color: '#3B6FD4', letterSpacing: '0.25em', textTransform: 'uppercase'
              }}>OPPRETT KONTO</span>
            </div>

            <h2 style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(42px, 6vw, 80px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.9, letterSpacing: '-0.03em',
              textTransform: 'uppercase', margin: '0 0 8px'
            }}>BLI EN DEL</h2>
            <h2 style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(36px, 5vw, 68px)',
              fontWeight: 700, color: '#E8941A',
              lineHeight: 0.95, letterSpacing: '-0.02em',
              margin: '0 0 32px'
            }}>av NordPass.</h2>

            <p style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '1.05rem', color: 'rgba(238,240,242,0.55)',
              lineHeight: 1.7, maxWidth: '400px', margin: '0 0 40px'
            }}>
              Registrer deg gratis og fa tilgang til Norges mest presise veikart, bomkalkulator og personlige ruteplanlegger - alt pa ett sted.
            </p>

            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
              <Link
                to="/login"
                style={{
                  display: 'inline-block',
                  background: '#E8941A',
                  padding: '16px 36px',
                  fontFamily: 'Syne, sans-serif', fontSize: '0.8rem',
                  fontWeight: 700, color: '#050A12',
                  letterSpacing: '0.12em', textTransform: 'uppercase',
                  textDecoration: 'none',
                  clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))'
                }}
              >
                OPPRETT GRATIS KONTO
              </Link>

              <Link
                to="/nord-pass-landing-page"
                style={{
                  display: 'inline-block',
                  padding: '16px 28px',
                  fontFamily: 'Syne, sans-serif', fontSize: '0.8rem',
                  fontWeight: 600, color: 'rgba(238,240,242,0.55)',
                  letterSpacing: '0.1em', textTransform: 'uppercase',
                  textDecoration: 'none',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                SE ALLE PLANER
              </Link>
            </div>

            <div style={{
              marginTop: '28px',
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '0.75rem', color: 'rgba(238,240,242,0.25)',
              borderLeft: '2px solid rgba(255,255,255,0.08)',
              paddingLeft: '14px', lineHeight: 1.5
            }}>
              Ingen kredittkort nodvendig.<br />
              Oppgrader nar som helst.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccountCTA;